import React from 'react';
import {
    Button,
    Form,
    Input,
    TextArea,
    Segment,
    Grid,
    Loader,
    Header,
    Radio,
    Select,
    Message,
    Card,
    Divider,
    Checkbox
} from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import { ToastContainer } from 'react-toastify';


export default class RadioQuestionForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            option1:[{value: 0,key:0,text: 0},{value: 1,key:1,text: 1}
            ],
            option2:[{value: 2,key:2,text: 2},{value: 3,key:3,text: 3},{value: 4,key:4,text: 4},{value: 5,key:5,text: 5},{value: 6,key:6,text: 6},{value: 7,key:7,text: 7},{value: 8,key:8,text: 8},{value: 9,key:9,text: 9},{value: 10,key:10,text: 10}],
            option3:[{value: 1,key:'on',text: "Uključi"},{value: 0,key:'off',text: "Isključi"}]

        };
        this.setOptions = this.setOptions.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }


    componentDidMount() {
        this.setOptions()

    }



    setOptions(){
        let options=[]
        for (let i =1 ; i<= 5; i=i+1 ){
            options.push(i)
        }
        this.setState({options})
    }

    handleChange = (e, { value }) => { //console.log(this.state.value);
         this.setState({ value })};
    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }
    resetForm(){
        this.setState({
            text: '',
            section: '',
            np: '',
            from:'',
            to: ''
        })
    }

    render() {

        return (
            <div>

                <Form>
                    <Form.Group widths='equal'>
                <Form.Field required error={this.state.titleErr}>
                    <label>
                        {<FormattedMessage id="poll.question" />}
                        {/*Pitanje*/}
                    </label>
                    <FormattedMessage id="poll.placeholderQuestion">
                        {(msg) => (<input
                            required
                            fluid
                            placeholder={msg}
                            control={Input}
                            value={this.state.title}
                            name="text"
                            onChange={(e) => this.setState({ text: e.target.value })}

                        />)}
                    </FormattedMessage>
                </Form.Field>
                    </Form.Group>
                    <Form.Group widths='equal'>
                        <Form.Field>
                            <label>
                                {<FormattedMessage id="poll.section" />}
                            </label>
                            <Form.Dropdown
                                clearable
                                placeholder={<FormattedMessage id="common.section" />}
                                value={this.state.section}
                                onChange={this.handleInputChange}
                                name="section"
                                options={this.props.sections}
                                search
                                fluid
                                selection
                                required
                                error={this.state.sectionErr}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>
                                {/*{<FormattedMessage id="common.intervalEnd" />}*/}
                                {/*Do:*/}
                                Np
                            </label>
                            <Form.Dropdown
                                clearable
                                // placeholder={<FormattedMessage id="common.intervalEnd" />}
                                placeholder={'NP'}
                                value={this.state.np}
                                onChange={this.handleInputChange}
                                name="np"
                                options={this.state.option3}
                                search
                                fluid
                                selection
                                required
                                error={this.state.toErr}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>
                                {<FormattedMessage id="common.intervalStart" />}
                                {/*Od:*/}
                            </label>
                            <Form.Dropdown
                                clearable
                                placeholder={<FormattedMessage id="common.intervalStart" />}
                                value={this.state.from}
                                onChange={this.handleInputChange}
                                name="from"
                                options={this.state.option1}
                                search
                                fluid
                                selection
                                required
                                error={this.state.fromErr}
                            />
                        </Form.Field>
                    <Form.Field>
                        <label>
                             {<FormattedMessage id="common.intervalEnd" />}
                            {/*Do:*/}
                        </label>
                        <Form.Dropdown
                            clearable
                            placeholder={<FormattedMessage id="common.intervalEnd" />}
                            value={this.state.to}
                            onChange={this.handleInputChange}
                            name="to"
                            options={this.state.option2}
                            search
                            fluid
                            selection
                            required
                            error={this.state.toErr}
                        />
                    </Form.Field>



                    </Form.Group>

                </Form>

                        <Button
                            onClick={()=>{this.resetForm();this.props.resetForm() }}
                            floated="right"
                            color="blue"
                            basic
                        >
                            {<FormattedMessage id="poll.cancel" />}
                        </Button>
                        <Button
                            onClick={()=>this.props.createQuestion(this.state.text, this.state.section,this.state.np, this.state.from,this.state.to)}
                            floated="right"
                            color="blue"
                            primary
                        >
                            {<FormattedMessage id="poll.addQuestionButton" />}
                        </Button>




            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/QuestionForms/RadioQuestionForm.js